import { formatRail } from "@/shared/utils/railDisplay";

import type { TaxScopeGroup } from "../../types/paymentTaxes.types";

export const sameScope = (
  a: Pick<TaxScopeGroup, "rail" | "direction">,
  b: Pick<TaxScopeGroup, "rail" | "direction">,
) => a.rail === b.rail && a.direction === b.direction;

/** The scope with "every rail" spelled out, for a rule shown away from its own row. */
export function scopeLabel(
  group: Pick<TaxScopeGroup, "rail" | "direction">,
  t: (key: "where_all" | "where_payin" | "where_payout" | "where_any_rail") => string,
): string {
  return group.rail ? whereLabel(group, t) : `${whereLabel(group, t)} · ${t("where_any_rail")}`;
}

export function whereLabel(
  group: Pick<TaxScopeGroup, "rail" | "direction">,
  t: (key: "where_all" | "where_payin" | "where_payout") => string,
): string {
  const direction = t(
    group.direction === "PAYIN" ? "where_payin" : group.direction === "PAYOUT" ? "where_payout" : "where_all",
  );
  return group.rail ? `${direction} · ${formatRail(group.rail)}` : direction;
}
